import styled from "styled-components";
import { Button, Col, Offcanvas } from "react-bootstrap";

export const MobileSidebarWrapper = styled.div`
  padding: 0.5rem;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const MenuButton = styled(Button)`
  width: 40px;
  height: 40px;
  padding: 8px;
  border-radius: 10px;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
`;

export const DesktopSidebar = styled(Col)`
  display: none;
  flex-direction: column;
  background-color: var(--color-containers-bg);

  height: 100vh;
  overflow: hidden;

  @media (min-width: 768px) {
    display: flex;
  }
`;

export const MobileOffcanvas = styled(Offcanvas)`
  width: 56px !important;
  max-width: 56px !important;
  background-color: var(--color-containers-bg);

  @media (min-width: 768px) {
    display: none;
  }
`;

export const MobileOffcanvasBody = styled(Offcanvas.Body)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
`;

export const IconGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.5rem 0.25rem;
`;
